import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { fontStyle } from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj({
		/* stylelint-disable-next-line */
		'h2&': fontStyle({
			...styles?.h2?.typography,
			textAlign: styles?.h2?.textAlignment,
			color: styles?.h2?.color,
		}),

		/* stylelint-disable-next-line */
		'h3&': fontStyle({
			...styles?.h3?.typography,
			textAlign: styles?.h3?.textAlignment,
			color: styles?.h3?.color,
		}),

		/* stylelint-disable-next-line */
		'h4&': fontStyle({
			...styles?.h4?.typography,
			textAlign: styles?.h4?.textAlignment,
			color: styles?.h4?.color,
		}),
	});

const getStyles = (styles) => css(getDynamicStyles(styles));

export { getStyles };
